export default class User {
  constructor(username, email, password, createdTime, modifiedTime) {
    this.username = username;
    this.email = email;
    this.password = password;
  }
}
